"use client";

import { authStoreClient } from "@/lib/auth-client";
import { YnsLink } from "@/ui/yns-link";
import { AuthUIProvider } from "@daveyplate/better-auth-ui";
import type { SocialProvider } from "better-auth/social-providers";
import { useRouter } from "next/navigation";
import { type ComponentProps, type ReactNode, Suspense } from "react";

type AuthClient = ComponentProps<typeof AuthUIProvider>["authClient"];

export const AuthProvider = ({
	redirectTo,
	baseURL,
	providers = [],
	children,
	authClient,
}: {
	children: ReactNode;
	redirectTo: string;
	baseURL: string;
	providers?: SocialProvider[];
	authClient: AuthClient;
}) => {
	const router = useRouter();

	return (
		<Suspense>
			<AuthUIProvider
				authClient={authClient}
				navigate={router.push}
				replace={router.replace}
				onSessionChange={() => {
					// Clear router cache (protected routes)
					router.refresh();
				}}
				Link={YnsLink}
				providers={providers}
				baseURL={baseURL}
				viewPaths={{
					signIn: "login",
					signUp: "signup",

					callback: "callback",
					forgotPassword: "forgot-password",
					magicLink: "magic-link",
					resetPassword: "reset-password",
					settings: "settings",
					signOut: "sign-out",
				}}
				redirectTo={redirectTo}
			>
				{children}
			</AuthUIProvider>
		</Suspense>
	);
};

export const AuthStoreProvider = ({
	storeBaseUrl,
	children,
}: { storeBaseUrl: string; children: ReactNode }) => {
	return (
		<AuthProvider authClient={authStoreClient(storeBaseUrl)} redirectTo={"/"} baseURL={storeBaseUrl}>
			{children}
		</AuthProvider>
	);
};
